(() => {
  const key = "hc-storefront-saved-v1";
  const validHandle = (value) =>
    typeof value === "string" && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const normalize = (value) =>
    Array.isArray(value)
      ? [...new Set(value.filter(validHandle))].slice(0, 200)
      : [];
  const read = () => {
    try {
      return normalize(JSON.parse(window.localStorage.getItem(key) || "[]"));
    } catch {
      return [];
    }
  };
  let handles = read();
  const render = () => {
    document
      .querySelectorAll("[data-saved-toggle][data-product-handle]")
      .forEach((button) => {
        button.setAttribute(
          "aria-pressed",
          String(handles.includes(button.dataset.productHandle)),
        );
      });
    document.querySelectorAll("[data-saved-count]").forEach((count) => {
      count.textContent = String(handles.length);
    });
  };
  const publish = () => {
    render();
    document.dispatchEvent(
      new CustomEvent("sf:saved-change", {
        detail: { handles: [...handles], count: handles.length },
      }),
    );
  };
  const save = (next) => {
    handles = normalize(next);
    try {
      window.localStorage.setItem(key, JSON.stringify(handles));
    } catch {
      // In-memory controls remain usable when browser storage is denied.
    }
    publish();
  };
  document.addEventListener("click", (event) => {
    const button = event.target.closest(
      "[data-saved-toggle][data-product-handle]",
    );
    if (!button || !validHandle(button.dataset.productHandle)) return;
    event.preventDefault();
    const handle = button.dataset.productHandle;
    save(
      handles.includes(handle)
        ? handles.filter((item) => item !== handle)
        : [...handles, handle],
    );
  });
  window.addEventListener("storage", (event) => {
    if (event.key !== key && event.key !== null) return;
    handles = read();
    publish();
  });
  document.addEventListener("shopify:section:load", render);
  window.StorefrontSaved = Object.freeze({
    getHandles: () => [...handles],
    has: (handle) => handles.includes(handle),
    remove: (handle) => save(handles.filter((item) => item !== handle)),
    refresh: render,
  });
  publish();
})();
